import Alpine from 'alpinejs';

export function guests(config = {}) {
    return {
        maxGuests: null,
        isAdjustingGuests: false,
        wasOpenOnPointerDown: false,

        init() {
            const parsedMaxGuests = Number(config?.maxGuests);
            this.maxGuests =
                Number.isFinite(parsedMaxGuests) && parsedMaxGuests > 0
                    ? Math.floor(parsedMaxGuests)
                    : null;

            this.$store.search.updateGuests();

            this.$watch('$store.search.adults', () =>
                this.enforceMaxGuests('adults')
            );
            this.$watch('$store.search.children', () =>
                this.enforceMaxGuests('children')
            );
            this.$watch('$store.search.pets', () => {
                const searchStore = this.$store.search;
                searchStore.pets = searchStore.clampPetCount(searchStore.pets);
            });
        },

        capturePopoverState(popoverKey) {
            this.wasOpenOnPointerDown = this.$store.popovers.isOpen(popoverKey);
        },

        openPopover(popoverKey) {
            this.$store.popovers.open(popoverKey);
        },

        focusTrigger(trigger) {
            if (typeof trigger?.focus === 'function') {
                trigger.focus({ preventScroll: true });
            }
        },

        blurTrigger(trigger) {
            if (typeof trigger?.blur === 'function') {
                trigger.blur();
            }
        },

        togglePopover(popoverKey, trigger = null) {
            if (
                this.wasOpenOnPointerDown &&
                this.$store.popovers.isOpen(popoverKey)
            ) {
                this.$store.popovers.close(popoverKey);
                this.blurTrigger(trigger);
            } else {
                this.$store.popovers.open(popoverKey);
                this.focusTrigger(trigger);
            }

            this.wasOpenOnPointerDown = false;
        },

        togglePopoverFromKeyboard(popoverKey) {
            if (this.$store.popovers.isOpen(popoverKey)) {
                this.$store.popovers.close(popoverKey);
            } else {
                this.$store.popovers.open(popoverKey);
            }
        },

        enforceMaxGuests(changedField) {
            if (this.isAdjustingGuests) {
                return;
            }

            const searchStore = this.$store.search;
            searchStore.updateGuests();

            if (!this.maxGuests || searchStore.guests <= this.maxGuests) {
                return;
            }

            const adults = Math.max(0, Number(searchStore.adults) || 0);
            const children = Math.max(0, Number(searchStore.children) || 0);
            const overflow = adults + children - this.maxGuests;

            let nextAdults = adults;
            let nextChildren = children;

            if (changedField === 'children') {
                nextChildren = Math.max(0, children - overflow);
            } else {
                nextAdults = Math.max(0, adults - overflow);
            }

            this.isAdjustingGuests = true;
            searchStore.adults = nextAdults;
            searchStore.children = nextChildren;
            searchStore.updateGuests();
            window.dispatchEvent(
                new CustomEvent('listing:guest-limit', {
                    detail: { maxGuests: this.maxGuests }
                })
            );

            queueMicrotask(() => {
                this.isAdjustingGuests = false;
            });
        }
    };
}

document.addEventListener('alpine:init', () => {
    Alpine.data('guests', guests);
});
